import React, { FunctionComponent, memo, ReactElement, useMemo } from 'react'
import LibImage from '@sport1/react-elements/Image'
import withTheme from '@sport1/react-elements/withTheme'
import { getImageSource, useImageSource } from '../../../utils/ImageHelper'
import { ImageProps } from '..'

const BaseImage = ({
    imageUrl,
    size,
    width = '100%',
    maxHeight,
    aspectRatio = '16:9',
    radiusType = 'none',
    testID,
    blurRadius,
    tintColor,
    theme,
    alt,
    title,
    resizeMode,
    height,
    //TODO: https://sport1digital.atlassian.net/browse/ML-4550 needs to be refactored
    ignoreAspectRatio,
}: ImageProps): ReactElement => {
    const breakpoints: number[] | undefined = theme?.breakpoints?.map(breakpoint =>
        parseInt(breakpoint, 10)
    )
    const [imageData, onError] = useImageSource({
        width,
        size,
        aspectRatio,
        radiusType,
        breakpoints,
        imageUrl,
    })

    const image = useMemo(
        () => (
            <LibImage
                testID={`${testID}_baseImage`}
                src={getImageSource(imageData)}
                width={width}
                aspectRatio={ignoreAspectRatio ? undefined : imageData.ratio}
                borderRadius={imageData.borderRadius}
                onError={onError}
                blurRadius={blurRadius}
                tintColor={tintColor}
                maxHeight={maxHeight}
                alt={alt}
                title={title}
                resizeMode={resizeMode}
                height={height}
            />
        ),
        [
            testID,
            imageData,
            width,
            ignoreAspectRatio,
            onError,
            blurRadius,
            tintColor,
            alt,
            resizeMode,
            title,
            maxHeight,
            height,
        ]
    )

    return Array.isArray(imageData.source) && imageData.source.length === breakpoints?.length ? (
        <picture data-testid={`${testID}_picture`} style={{ display: 'flex', height: '100%' }}>
            {imageData.source.map((sourceUrl, index) => (
                <source
                    key={`${sourceUrl}-${index}`}
                    media={
                        index + 1 === breakpoints?.length
                            ? `(min-width: ${breakpoints[index - 1]}px)`
                            : `(max-width: ${breakpoints[index]}px)`
                    }
                    srcSet={sourceUrl}
                />
            ))}
            {image}
        </picture>
    ) : (
        image
    )
}

export default memo(withTheme(BaseImage)) as FunctionComponent<ImageProps>
